function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 15"
}, props), React.createElement("path", {
  d: "M7.5 0C3.4 0 0 3.4 0 7.5c0 3.2 2.1 6.1 5.1 7.1.4.1.5-.2.5-.4v-1.4c-2.1.5-2.5-.8-2.5-.8-.3-.9-.8-1.1-.8-1.1-.7-.5 0-.5 0-.5.8.1 1.2.8 1.2.8.7 1.1 1.8.8 2.2.6.1-.5.3-.8.5-1-1.7-.2-3.5-.8-3.5-3.7 0-.8.3-1.5.8-2-.1-.2-.3-1 .1-2 0 0 .6-.2 2.1.8.6-.2 1.2-.3 1.9-.3.6 0 1.3.1 1.9.3 1.4-1 2.1-.8 2.1-.8.4 1 .1 1.8.1 2 .5.5.8 1.2.8 2 0 2.9-1.8 3.5-3.4 3.7.3.2.5.7.5 1.4v2.1c0 .2.1.4.5.4 3.9-1.3 6.1-5.6 4.7-9.5C13.6 2.1 10.7 0 7.5 0",
  fillRule: "evenodd",
  clipRule: "evenodd"
})));